import { FC, ReactElement } from 'react';
import Link from 'next/link';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { LearnMode, PageInfoHeaderSkeleton } from '@whitesharx/starfall-frontend-core';
import { LearnSkeleton } from '@whitesharx/starfall-frontend-core/learn_screen';

import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { InfoHeaderSkeleton } from '~/src/components/InfoHeader/InfoHeaderSkeleton';

import { ROUTES_BY_MODE } from '~/pages/learn';
import { linkStyles, pageTitleBlurStyles } from '~/styles/pages/common.css';

const LearnSkeletonPage: FC = () => {
  const link = (mode: LearnMode) => (children: ReactElement) =>
    (
      <Link passHref href={ROUTES_BY_MODE[mode]}>
        <a className={linkStyles}>{children}</a>
      </Link>
    );

  return (
    <PageLayoutSkeleton rightContainer={<UserInfoSkeleton />}>
      <InfoHeaderSkeleton />
      <PageInfoHeaderSkeleton title={t('learn.page-title')} name="learn" textClassName={pageTitleBlurStyles} />
      <LearnSkeleton link={link} />
    </PageLayoutSkeleton>
  );
};

export default LearnSkeletonPage;
